import React from 'react';
import { ProductSection, ProductGrid, Product, ProductImage } from './ProductCard';
import CustomModal from './CustomModal';
import { getProductImage } from '../function/util';

const ProductList = ({data, title}) => {
  const [openModal, setOpenModal] = React.useState(false);
  const [selectedItem, setSelectedItem] = React.useState({});

  const addToCart=(item)=>{
    setOpenModal(true);
    setSelectedItem(item);
  }

  if(openModal){
    return <CustomModal dItem={selectedItem} />
  }

  if(data?.length<=0){
    return (
      <div style={{textAlign: "center", padding: "40px 20px"}}>No Data</div>
    )
  }

  return (
    <ProductSection>
        <h2>{title}</h2>
        <ProductGrid>
        {data?.map((product) => (
            <Product key={product.id}>
                <ProductImage src={getProductImage(product)} alt={product.name} />
                <p className="lineClamp1">{product.description}</p>
                <p>${product.variants[0].price}</p>
                <button className="mainbutton" onClick={()=>addToCart(product)}>Add to cart</button>
            </Product>
        ))}
        </ProductGrid>
    </ProductSection>
  );
}

export default ProductList;
